import React from 'react';
import { Wrapper, Title, Textarea } from './styled';

export const renderTextarea = ({
  input,
  title,
  placeholder,
  meta: {touched, error}
}) => {

  return(
    <Wrapper error={touched && error}>
      {title && <Title>{title}</Title>}
      <Textarea
        {...input}
        rows={5}
        cols={1}
        placeholder={placeholder}
      />
      {(touched && error) && <span>{error}</span>}
    </Wrapper>
)}